import { groupLifeProposalsService } from '@/services/proposals/group-life';
import type { GroupLifeSubmitProposalAnalysisResponse } from '@/services/proposals/group-life';
import { useMutation, useQueryClient } from '@tanstack/react-query';

type Variables = {
  policyId: string;
};

/**
 * Aprova a proposta PME em análise (StatusPortal 18) — passa a "Proposta
 * Aceita" (7) e volta para as mãos do corretor.
 *
 * A aprovação NÃO dispara assinatura: quem faz isso é o Confirmar do corretor,
 * no Resumo, que é de onde sai o mapping da carta comercial. O 7 também é o
 * marcador que impede o Confirmar de devolver a proposta para a subscrição.
 */
export function useSubmitGroupLifeProposalAnalysis() {
  const queryClient = useQueryClient();

  return useMutation<GroupLifeSubmitProposalAnalysisResponse, Error, Variables>(
    {
      mutationKey: ['group-life-proposal', 'submit-analysis-calculation'],
      mutationFn: async ({ policyId }) => {
        const response =
          await groupLifeProposalsService.submitProposalAnalysisCalculation(
            policyId
          );
        if (!response.success || !response.data) {
          throw Object.assign(
            new Error(response.error || 'Erro ao aprovar proposta em análise'),
            { statusCode: response.status }
          );
        }
        return response.data;
      },
      onSuccess: (_data, variables) => {
        queryClient.invalidateQueries({ queryKey: ['proposal-analyses'] });
        queryClient.invalidateQueries({
          queryKey: ['group-life-proposal', variables.policyId],
        });
        // A aprovação libera o compliance: o critério muda na grade.
        queryClient.invalidateQueries({
          queryKey: ['group-life', 'underwriting-messages', variables.policyId],
        });
        queryClient.invalidateQueries({ queryKey: ['proposals'] });
      },
    }
  );
}
